import { render, staticRenderFns } from "./affiliate-programme.vue?vue&type=template&id=b812d1d4"
import script from "./affiliate-programme.vue?vue&type=script&lang=js"
export * from "./affiliate-programme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports